<template>
  <v-row>
    <v-col class="xs mt-2" offset-lg="1" lg="10">
      <v-breadcrumbs :items="items" divider=">" class="pl-1" />
      <v-card>
        <v-card-title class="theme">
          <v-icon class="white--text">fact_check</v-icon>
          <span class="headline ml-1 white--text">Incoming time off requests</span>
          <v-spacer/>
        </v-card-title>
        <v-divider/>
        <v-card-text>
          <v-data-table
              flat
              v-if="timeOffs"
              :items="timeOffs"
              hide-default-footer
              disable-pagination
              class="row-pointer"
              :headers="headers">
            <template v-slot:item.user_name="{ item }">
              <td class="text-capitalize">{{ item.user_name }}</td>
            </template>
            <template v-slot:item.type="{ item }">
              <td v-if="item.type==='Sick Leave'">
                <v-icon small class="mr-2 mb-1 theme-text">medical_services</v-icon>
                {{ item.type }}
              </td>
              <td v-else-if="item.type==='Vacation'">
                <v-icon small class="mr-2 mb-1 theme-text">beach_access</v-icon>
                {{ item.type }}
              </td>
              <td v-else>
                <v-icon small class="mr-2 mb-1 theme-text">grass</v-icon>
                Others
              </td>
            </template>

            <template v-slot:item.start_date="{ item }">
              <td>{{ ddmmyyyy(item.start_date) }}</td>
            </template>

            <template v-slot:item.end_date="{ item }">
              <td>{{ ddmmyyyy(item.end_date) }}</td>
            </template>

            <template v-slot:item.status="{ item }">
              <v-btn
                  small
                  v-if="item.status === 'Pending'"
                  class="action rounded-sm white--text"
                  depressed
                  text
                  @click="handleChange(item)"
              >Approve / Reject
              </v-btn>
              <div v-else-if="item.status === 'Approved' " class="success--text">
                {{ item.status }}
              </div>
              <div v-else class="error--text">{{ item.status }}</div>
            </template>
            <template v-slot:item.id="{ item }">
              <div v-if="item.status === 'Approved'">
                <v-btn @click="deleteRequest(item)" small fab text>
                  <v-icon small class="error--text">delete</v-icon>
                </v-btn>
              </div>
            </template>
            <template v-slot:no-data>No data</template>
            <template v-slot:footer>
              <div class="text-center mt-5">
                <v-btn
                    fab
                    small
                    color="theme white--text"
                    depressed
                    @click="previous"
                    :disabled="pagination.page <= 0"
                >
                  <v-icon small>navigate_before</v-icon>
                </v-btn>
                <span>
                  <v-btn text :disabled="true">{{ pagination.page + 1 }}</v-btn>
                </span>
                <v-btn
                    fab
                    small
                    depressed
                    color="theme white--text"
                    @click="next"
                    :disabled="pagination.disableNext"
                >
                  <v-icon small>navigate_next</v-icon>
                </v-btn>
              </div>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-col>
    <v-dialog v-model="approval_dialog" persistent max-width="500px">
      <v-card flat>
        <v-card-title class="theme">
          <span class="headline white--text">Approve TimeOff Request</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="approval_dialog = !approval_dialog">
            <v-icon class="white--text">close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" class="theme-text subtitle-1">
              Approval request from {{ currentItem.user_name }}
            </v-col>
            <v-col cols="12" sm="5" class="text-right">
              <v-icon x-large class="theme-text">date_range</v-icon>
              <div class="theme-text title">
                {{ getDay(currentItem.start_date) }}
              </div>
              <div>{{ currentItem.start_date_formatted }}</div>
            </v-col>
            <v-col cols="12" sm="2" class="text-center">
              <v-icon x-large class="theme-text">arrow_right_alt</v-icon>
            </v-col>
            <v-col cols="12" sm="5" class="text-left">
              <v-icon x-large class="theme-text">date_range</v-icon>
              <div class="theme-text title">
                {{ getDay(currentItem.end_date) }}
              </div>
              <div>{{ currentItem.end_date_formatted }}</div>
            </v-col>

            <v-col cols="12">
              <div class="subtitle-1 theme-text">Description</div>
              <div>{{ currentItem.description }}</div>
            </v-col>

            <v-col cols="12">
              <v-divider></v-divider>
              <div class="my-3 subtitle-1 theme-text">Message</div>
              <v-textarea
                  dense
                  rows="3"
                  label="Message to employee"
                  placeholder="Add a reason for rejection or an optional reason for approval"
                  v-model="currentItem.text"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn
              depressed
              class="ml-4 error white--text rounded-sm"
              @click="update(false)"
          >Reject
          </v-btn>
          <v-spacer/>
          <v-btn
              depressed
              class="save white--text rounded-sm mr-4"
              @click="update(true)"
          >approve
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="delete_request_dialog" persistent max-width="500px">
      <v-card flat>
        <v-card-title class="theme">
          <span class="headline white--text">Delete timeoff request</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="delete_request_dialog = !delete_request_dialog">
            <v-icon class="white--text">close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" class="subtitle-1 mt-4">
              Are you sure? On confirming, the request will be deleted from the system
              and the time off days will be credited back to employee's balance.
            </v-col>
            <v-col cols="12" class="body-2">
              <div class="title-1 theme-text">Request details</div>
              <div class="title-1 mt-2">Employee name : <span class="text-capitalize">{{
                  rollbackItem.user_name
                }}</span></div>
              <div class="title-1">Timeoff dates : {{ rollbackItem.start_date_formatted }} -
                {{ rollbackItem.end_date_formatted }}
              </div>
              <div class="title-1">Total days : {{ rollbackItem.total_days }}</div>
            </v-col>

          </v-row>
        </v-card-text>
        <v-divider></v-divider>

        <v-card-actions>

          <v-btn
              depressed
              class="save white--text rounded-sm mr-2"
              @click="rollbackTimeoffRequest"
          >Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar" :bottom="true" :right="true">
      {{ snackbarMessage }}
      <v-btn color="pink" text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </v-row>
</template>
<script>
import {mapGetters} from 'vuex';

import {Actions} from '@/views/actions';
import {Breadcrumbs} from '@/views/breadcrumbs';
import {Component} from '@/views/component';
import {Constants} from '@/views/constants';
import {TableHeaders} from '@/views/headers';

export default {
  name: Component.Protected.TimeOff.Approve,
  computed: {
    ...mapGetters(["userInfo", "timeOffs"]),
    computedStartDateFormatted() {
      return this.datePickerFormat(this.startDate);
    },
    computedEndDateFormatted() {
      return this.datePickerFormat(this.endDate);
    },
  },
  data: () => ({
    delete_request_dialog: false,
    approval_dialog: false,
    endDateModal: false,
    startDateModal: false,
    items: Breadcrumbs.TimeOff.Approve,
    headers: TableHeaders.TimeOff.Approve,
    approver: {},
    description: null,
    leaveType: null,
    startDate: null,
    endDate: null,
    statusList: Constants.TimeOff.Status.All,
    currentItem: {},
    rollbackItem: {},
    days: [
      'Sunday',
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday',
      'Saturday',
    ],
    search: {limit: 10, offset: 0},
    pagination: {disableNext: true, page: 0},

  }),
  methods: {
    rollbackTimeoffRequest() {
      this.$store.dispatch(Actions.TimeOff.Rollback, this.rollbackItem.id).then(() => {
        this.rollbackItem = {}
        this.getTimeOffs();
        this.delete_request_dialog = false;
      }).catch
      ((err) => {
        console.error(Constants.TimeOff.Messages.Error.Edit, err);
        this.snackbar = true;
        this.snackbarMessage = Constants.TimeOff.Messages.Error.Edit;
      }).finally(() => {
        this.$forceUpdate();
      });
    },
    deleteRequest(item) {
      this.delete_request_dialog = true
      this.rollbackItem = {...item}
    },
    next() {
      if (this.pagination.page < 0) {
        this.pagination.page = 0;
        this.search.offset = 0;
      } else if (this.timeOffs.length <= this.search.limit) {
        this.pagination.page++;
        this.search.offset = this.search.limit * this.pagination.page;
        this.getTimeOffs();
      }
    },
    previous() {
      this.pagination.page--;
      if (this.pagination.page < 0) {
        this.pagination.page = 0;
        this.search.offset = 0;
      } else {
        this.search.offset = this.search.limit * this.pagination.page;
        this.getTimeOffs();
      }
    },
    ddmmyyyy(item) {
      if (!item) return false;
      let dt = item.split('-');
      if (dt.length !== 3) return false;
      let year = dt[0];
      let mm = `${dt[1]}`;
      let dd = dt[2];
      return `${dd.padStart(2, '0')}-${mm.padStart(2, '0')}-${year}`;
    },
    update(ok) {
      if (ok) {
        this.currentItem.status = Constants.TimeOff.Status.Approved;
      } else {
        this.currentItem.status = Constants.TimeOff.Status.Rejected;
      }
      let payload = {id: this.currentItem.id, data: this.currentItem};
      this.$store
          .dispatch(Actions.TimeOff.Edit, payload)
          .then(() => {
            this.currentItem = {};
            this.getTimeOffs();
            this.approval_dialog = false;
          })
          .catch((err) => {
            console.error(Constants.TimeOff.Messages.Error.Edit, err);
            this.snackbar = true;
            this.snackbarMessage = Constants.TimeOff.Messages.Error.Edit;
          })
          .finally(() => {
            this.$forceUpdate();
          });
    },
    getDay(item) {
      if (!item) return false;
      let dt = item.split("-");
      if (dt.length !== 3) return false;

      let year = parseInt(dt[2]);
      let mm = parseInt(dt[1] - 1);
      let dd = parseInt(dt[0]);
      let date = new Date(year, mm, dd);
      return this.days[date.getDay()];
    },
    handleChange(item) {
      this.currentItem = {
        ...item,
        leave_id: item.leave_type_id,
        start_date: this.ddmmyyyy(item.start_date),
        end_date: this.ddmmyyyy(item.end_date)
      };
      this.approval_dialog = true;
    },
    resetModel() {
      this.endDate = new Date().toISOString().substring(0, 10);
      this.startDate = new Date().toISOString().substring(0, 10);
      this.leaveType = null;
      this.description = null;
      this.add_entity_dialog = false;
    },
    getTimeOffs() {
      let payload = {... this.search}
      if (this.userInfo.role === Constants.Roles.Manager){
        payload.approver_id = this.userInfo.userID
      }
      this.$store.dispatch(Actions.TimeOff.Find, payload).then(() => {
        let len = this.timeOffs.length;
        if ((len < this.search.limit && len > 0) || len === 0) {
          this.pagination.disableNext = true;
        } else if (len === this.search.limit) {
          this.pagination.disableNext = false;
        }
      }).catch((err) => {
        console.error(Constants.TimeOff.Messages.Error.Find, err);
        this.snackbar = true;
        this.snackbarMessage = Constants.TimeOff.Messages.Error.Find;
      });
    },
    setup() {
      if (this.userInfo.role !== Constants.Roles.HR && this.userInfo.role !== Constants.Roles.Manager) {
        this.$router.go(-1);
      }
      this.getTimeOffs();
    },
  },
  created() {
    this.resetModel();
    if (this.userInfo) {
      this.setup();
    } else {
      this.$store.dispatch(Actions.Firebase.UserInfo).then(() => this.setup());
    }
  },
};
</script>
<style scoped>
* >>> div.v-picker__title {
  background-color: #551738 !important;
  border-color: #551738 !important;
}

* >>> div.v-date-picker-table {
  height: 200px !important;
}
</style>